export class SearchEntity {
  get id(): string {
    return toString();
  }
}
